import { t } from '@/plugins/i18n'

export const productColumns:any = [
  {
    label: t('图片'),
    prop: 'productMainImg',
    align: 'center',
    slotName: 'productMainImg'
  },
  {
    label: t('sku/平台商品信息'),
    prop: 'productSkuInfo',
    width: 250,
    align: 'center',
    slotName: 'productSkuInfo'
  },
  {
    label: t('平台商品sku'),
    prop: 'productSku',
    align: 'center',
    width: 200
  },
  {
    label: t('AMAZON商品名称'),
    prop: 'amazonProductTitle',
    align: 'center',
    width: 200
  },
  {
    label: t('海外仓sku(fnsku)'),
    prop: 'amazonFnsku',
    align: 'center',
    width: 200,
    sortable: 'amazonFnsku',
    slotName: 'amazonFnsku'
  },
  {
    label: t('asin'),
    prop: 'amazonAsin',
    align: 'center',
    width: 200
  },
  {
    label: t('库存数量'),
    prop: 'useable',
    align: 'center'
  },
  {
    label: t('补货数量'),
    prop: 'deliveryNums',
    align: 'center',
    slotName: 'deliveryNums',
    width: 150
  }
]

export const productApiConfig:any = {
  listPath: 'data'
}

export const productTableConfig = {
  showSelection: true
}

export const productTableConfig2 = {
  showSelection: true,
  showHandler: true,
  rowKey: 'productSku'
}
